export class SkpdModel {
  id: number;
  idInduk: number;
  kodeSkpd: string;
  kodeUnitKerja: string;
  namaSkpd: string;
  namaSingkatSkpd: string;
  blud: string; // 0 = skpd | 1 = blud
  statusAktif: string; // 0 = Tidak Aktif | 1 = Aktif
  tahunBerlaku: string;
  tahunBerakhir: string;
  idRekamPengguna: number;
  tanggalRekamPengguna: string
  idUbahPengguna: number;
  tanggalUbahPengguna: string;
  idLayanan: number;
}

export class SkpdBasModel {
  idSkpd: number
  idBas: number
  kodeSkpd: string
  namaSkpd: string
  kodeAkun: string
  namaAkun: string
}

export class SkpdPersetujuanModel {
  id: number;
  idInduk: number;
  kodeSkpd: string;
  kodeUnitKerja: string;
  namaSkpd: string;
  namaSingkatSkpd: string;
  blud: string; // 0 = skpd | 1 = blud
  statusAktif: string; // 0 = Tidak Aktif | 1 = Aktif
  tahunBerlaku: string;
  tahunBerakhir: string;
  idRekamPengguna: number;
  tanggalRekamPengguna;
  idUbahPengguna: number;
  tanggalUbahPengguna: string;
  totalAnggaran: number;
  statusDinasId: string;
  statusDinasName: string;
  statusDinasBadge: string;
  pergeseranCount: number;
  pelaksanaanCount: number;
  isLock: any;
}
